import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './index.css';                // ← ADD THIS
import 'mapbox-gl/dist/mapbox-gl.css';
import App from "./App.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
  <App />
  </BrowserRouter>
);
